<p>Hi {{authenticatedUser?.name}}</p>
<p>Account: {{authenticatedUserAccount?.name || 'Loading...'}}</p>
<p>Authorization of your Connect identity has failed.</p>
<div *ngIf="authorizationError">
  <p>Error code: <strong>{{authorizationError.errorCode}}</strong></p>
  <p>Error text: <em>{{authorizationError.errorText}}</em></p>
</div>
<button mat-raised-button color="primary" (click)="signout()">Sign Out</button>